import { HttpResponse } from '@angular/common/http';
import { Module, ModuleDto } from '@app/store/shared/models';

export class PaginatedDto {
    readonly payload: Module[];
    readonly total: number;

    constructor(response: HttpResponse<ModuleDto[]>) {
        this.payload = (response.body ?? []).map((dto) => new Module(dto));
        this.total = parseInt(response.headers.get('X-Total-Count') ?? '0', 10);
    }
}
